(function ($) {
    'use strict';
    $(document).ready(function () {
        $('a.nav-link.dropdown-toggle').click(function () {
            location.href = this.href;
        });

        $('body').on('click', '.get-in-touch-with-form-section .gform_button.button', function () {
            // $(this).html('Sent <div class="btn-progress-bar"></div>');
            $(this).children('.btn-progress-bar').animate({ width: '100%' }, 80);
            setTimeout(() => {
                $(this).addClass('btn-sent');
            }, 80);
        });

        {
            let wpbsearchform = $(".wpbsearchform");
            const sfToggle = function searchformToggle() {
                if ( wpbsearchform.is(":visible") ) {
                    wpbsearchform.hide();
                } else {
                    wpbsearchform.show();
                }
            }
            $(".search-wpb .search-icon").click(function() {
                sfToggle();
            });
            wpbsearchform.find('form button[type="reset"]').click(function() {
                sfToggle();
            });
            $(document).keyup(function(e) {
                if (e.key == "Escape" && wpbsearchform.is(":visible")) {
                    sfToggle();
                }
            });
        }

    });

    $(window).load(function () {});
})(jQuery);
